import { Instrument } from "@ts/types/instrument.type"
import {
  Table,
  TableBody,
  TableCell,
  TableHeader,
  TableHeaderCell,
  TableRow,
} from "@components/dataDisplay/table/Table"
import styles from "./premarket.module.css"

const priceFormatter = new Intl.NumberFormat("de-CH", { minimumFractionDigits: 2, maximumFractionDigits: 2 })
const sizeFormatter = new Intl.NumberFormat("de-CH", { maximumFractionDigits: 0 })

const formatPrice = (n: number): string => priceFormatter.format(n).replaceAll("’", "'")
const formatSize = (n: number): string => sizeFormatter.format(n).replaceAll("’", "'")
const signClass = (n: number): "negative" | "positive" => (n < 0 ? "negative" : "positive")

const InstrumentsTable = ({ instruments }: { instruments: Instrument[] }) => {
  return (
    <Table>
      <TableHeader>
        <TableRow>
          <TableHeaderCell>Basiswert</TableHeaderCell>
          <TableHeaderCell align="right" hideOnMobile={true}>
            Size
          </TableHeaderCell>
          <TableHeaderCell align="right">Geld</TableHeaderCell>
          <TableHeaderCell align="right">Brief</TableHeaderCell>
          <TableHeaderCell align="right" className={styles.hide}>
            Size
          </TableHeaderCell>
          <TableHeaderCell align="right" hideOnMobile={true}>
            Change
          </TableHeaderCell>
          <TableHeaderCell align="right">%</TableHeaderCell>
        </TableRow>
      </TableHeader>
      <TableBody>
        {instruments.map((instrument: Instrument) => (
          <TableRow key={instrument.isin}>
            <TableCell shortenOnMobile={true}>{instrument.name}</TableCell>
            <TableCell align="right" hideOnMobile={true}>
              {formatSize(instrument.bidSize)}
            </TableCell>
            <TableCell align="right" className={styles.bold}>
              {formatPrice(instrument.bid)}
            </TableCell>
            <TableCell align="right" className={styles.bold}>
              {formatPrice(instrument.ask)}
            </TableCell>
            <TableCell align="right" hideOnMobile={true}>
              {formatSize(instrument.askSize)}
            </TableCell>
            <TableCell align="right" hideOnMobile={true} numberType={signClass(instrument.change)}>
              {formatPrice(instrument.change)}
            </TableCell>
            <TableCell align="right" numberType={signClass(instrument.changePercent)}>
              {formatPrice(instrument.changePercent)}%
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  )
}

export default InstrumentsTable
